<template>
    <div>
        <h4 class="mb-8">Chat Settings</h4>
        <div class="md:w-1/2 w-full">
            <div class="flex flex-wrap justify-between items-center my-4">
                <label>Allow students to chat each other</label>
                <vs-switch v-model="settings1" />
            </div>
            <div class="flex flex-wrap justify-between items-center my-4">
                <label>Allow students to chat you</label>
                <vs-switch v-model="settings2" />
            </div>
            <div class="flex flex-wrap justify-between items-center my-4">
                <label>Allow students to chat teachers</label>
                <vs-switch v-model="settings3" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      settings1: true,
      settings2: true,
      settings3: true
    }
  }
}
</script>